export default __webpack_public_path__ + "static/media/bg6.75cff010.jpg";